/**
 * @fileoverview ชื่อช่างสำหรับแสดงผล — รูปแบบมาตรฐานเดียวกับหน้าใบงาน: "ชื่อ นามสกุล (ชื่อเล่น)"
 * @module utils/technician
 */

const joinName = (first, last) => [first, last].filter(Boolean).join(" ").trim();

/**
 * รับได้ทั้ง record ช่างดิบ (first_name_th/last_name_th/nickname_th ...) และ option จาก backend รายงานช่าง ({name, nickname, code})
 * ไม่มีชื่อเล่นไม่ต่อวงเล็บ · ไม่มีชื่อ-นามสกุลเลย fallback เป็นชื่อเล่น แล้วรหัสช่าง
 * @param {object} technician
 * @param {string} [fallback] ค่าเมื่อไม่มีข้อมูลเลย
 * @returns {string}
 */
export const technicianDisplayName = (technician, fallback = "") => {
  if (!technician) return fallback;
  const name =
    String(technician.name || "").trim() ||
    joinName(technician.first_name_th, technician.last_name_th) ||
    joinName(technician.first_name_en, technician.last_name_en);
  const nickname = String(technician.nickname || technician.nickname_th || technician.nickname_en || "").trim();
  if (name) return nickname ? `${name} (${nickname})` : name;
  return nickname || technician.technician_code || technician.code || fallback;
};
